"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocaleSelectorModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _keys = _interopRequireDefault(require("lodash/keys"));
var _pickBy = _interopRequireDefault(require("lodash/pickBy"));
var _groupBy = _interopRequireDefault(require("lodash/groupBy"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _reactCookie = _interopRequireDefault(require("react-cookie"));
var _apiProfile = require("../../../../api/api-profile");
var _spinner = require("../decorators/spinner");
var _reactIntl = require("react-intl");
var _bootstrapModal = _interopRequireDefault(require("../search-module/components/bootstrap-modal"));
var _sharedIntlProviderHOC = _interopRequireDefault(require("../hocs/sharedIntlProviderHOC"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var LocaleSelectorModal = exports.LocaleSelectorModal = /*#__PURE__*/function (_React$Component) {
  _inherits(LocaleSelectorModal, _React$Component);
  function LocaleSelectorModal(props) {
    var _this;
    _classCallCheck(this, LocaleSelectorModal);
    _this = _callSuper(this, LocaleSelectorModal, [props]);
    var envLocaleMap = _sharedIntlProviderHOC.default.getEnvLocaleData();
    _this.state = {
      initialLocaleData: props.currentLocaleData,
      selectedLocaleData: props.currentLocaleData,
      localeData: props.activeLocales || envLocaleMap,
      profileUpdateHasError: false,
      profileUpdateLoading: false
    };
    _this.onLocaleChanged = _this.onLocaleChanged.bind(_assertThisInitialized(_this));
    _this.isSelected = _this.isSelected.bind(_assertThisInitialized(_this));
    _this.selectLocale = _this.selectLocale.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(LocaleSelectorModal, [{
    key: "onLocaleChanged",
    value: function onLocaleChanged() {
      var _this2 = this;
      var currentLocale = _reactCookie.default.load('preferred_locale') || _reactCookie.default.load('initial_locale');
      var accessToken = PSSessions.Cookies('PSAccess');
      var ssoID = PSSessions.Cookies('PSUser');
      if (currentLocale != this.state.selectedLocaleData.locale) {
        //locale changed
        this.setState({
          profileUpdateHasError: false,
          profileUpdateLoading: true
        });
        analyticsIntegrations.trackEvent("locale updated", {
          changed_from: this.state.initialLocaleData.locale,
          changed_to: this.state.selectedLocaleData.locale,
          ui_element: this.props.triggerSource,
          ssoid: ssoID
        });
        if (!accessToken) {
          //user not logged in, just change the cookie
          _reactCookie.default.save('preferred_locale', this.state.selectedLocaleData.locale, {
            path: '/',
            expires: new Date(Date.now() + 60 * 60 * 6 * 1000),
            domain: window.location.host,
            secure: -1 !== window.location.protocol.indexOf('s')
          });
          window.location.reload();
        } else {
          //user logged in, proceed to updating profile and cookie
          var profileBody = {
            preferred_locale: this.state.selectedLocaleData.locale
          };
          _apiProfile.Profile.update('me', accessToken, profileBody, function (response) {
            if (!response.error) {
              _reactCookie.default.save('preferred_locale', _this2.state.selectedLocaleData.locale, {
                path: '/',
                expires: new Date(Date.now() + 60 * 60 * 6 * 1000),
                domain: window.location.host,
                secure: -1 !== window.location.protocol.indexOf('s')
              });
              window.location.reload();
            } else {
              _this2.setState({
                selectedLocaleData: _this2.state.initialLocaleData,
                //reset to original locale since update didn't go through
                profileUpdateHasError: true,
                profileUpdateLoading: false
              });
            }
          });
        }
      }
    }
  }, {
    key: "isSelected",
    value: function isSelected(localeData) {
      return this.state.selectedLocaleData.locale == localeData.locale ? 'text-white btn-primary border-0' : 'border-gray-400 bg-hover-gray-100';
    }
  }, {
    key: "selectLocale",
    value: function selectLocale(localeData) {
      if (this.state.selectedLocaleData != localeData) {
        this.setState({
          selectedLocaleData: localeData
        }, this.onLocaleChanged);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        showModal = _this$props.showModal,
        onModalClose = _this$props.onModalClose;
      var _this$state = this.state,
        profileUpdateLoading = _this$state.profileUpdateLoading,
        profileUpdateHasError = _this$state.profileUpdateHasError,
        localeData = _this$state.localeData;
      var locales = (0, _keys.default)((0, _pickBy.default)(localeData, function (localeData) {
        return localeData.language && localeData.country;
      })); //we only want the locales with langauage and country. This will exclude the fallback locales in the data
      var envLocaleArray = locales.map(function (locale) {
        return _objectSpread(_objectSpread({}, localeData[locale]), {}, {
          locale: locale
        }); //[{"locale":"en","translations": "en-GB","url_prefix": "uk","region": "Europe","language": "English","country": "United Kingdom"}]
      });
      var envLocaleDataByRegion = (0, _groupBy.default)(envLocaleArray, 'region');
      return /*#__PURE__*/_react.default.createElement(_bootstrapModal.default, {
        showModal: showModal,
        modalSize: "md-size",
        modalClass: "padding-lg w-100",
        onClose: onModalClose,
        header: !profileUpdateLoading && /*#__PURE__*/_react.default.createElement("div", {
          className: "text-left",
          style: {
            marginTop: '-32px',
            marginBottom: '-16px'
          }
        }, /*#__PURE__*/_react.default.createElement("h5", {
          className: "no-margin"
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "shared_component.language_country_selector.header",
          defaultMessage: "Customize your experience"
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "text-gray-600 margin-md-top"
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "shared_component.language_country_selector.subheader",
          defaultMessage: "Set your preferred language and region"
        }))),
        bodyClass: "padding-lg",
        body: profileUpdateLoading ? /*#__PURE__*/_react.default.createElement("div", {
          style: {
            height: 400
          },
          className: "flex column center middle"
        }, /*#__PURE__*/_react.default.createElement(_spinner.Spinner, {
          additionalStyle: "gray"
        })) : /*#__PURE__*/_react.default.createElement("div", null, profileUpdateHasError && /*#__PURE__*/_react.default.createElement("div", {
          className: "text-red bg-gray-100 border-radius-sm padding-md-top padding-md-bottom padding-lg-left padding-lg-right border-radius-sm"
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "shared_component.language_country_selector.error_msg",
          defaultMessage: "Unknown error occured. Please try again."
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "flex column margin-lg-top"
        }, (0, _keys.default)(envLocaleDataByRegion).map(function (region) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "margin-lg-bottom",
            key: "".concat(region)
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "heavy margin-md-bottom"
          }, region), /*#__PURE__*/_react.default.createElement("div", {
            className: "flex flex-wrap no-margin"
          }, envLocaleDataByRegion[region].map(function (localeData, index) {
            return /*#__PURE__*/_react.default.createElement("div", {
              className: "col-xs-12 col-sm-12 col-md-4 no-gutter-left margin-lg-bottom",
              key: localeData.country
            }, /*#__PURE__*/_react.default.createElement("button", {
              onClick: function onClick() {
                _this3.selectLocale(localeData);
              },
              className: "btn-block btn text-xs-left ".concat(_this3.isSelected(localeData)),
              key: "".concat(region, "-lang-country-").concat(index)
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "heavy"
            }, localeData.language), /*#__PURE__*/_react.default.createElement("div", {
              className: "normal"
            }, localeData.country)));
          })));
        })))
      });
    }
  }]);
  return LocaleSelectorModal;
}(_react.default.Component);
LocaleSelectorModal.propTypes = {
  showModal: _propTypes.default.bool.isRequired,
  onModalClose: _propTypes.default.func.isRequired,
  currentLocaleData: _propTypes.default.object.isRequired,
  triggerSource: _propTypes.default.string.isRequired
};